// extracted by mini-css-extract-plugin
export default {"btn_style":"UserInfosUpdate_btn_style__cB1ao","form_field":"UserInfosUpdate_form_field__qEw3W"};